import update from 'immutability-helper';
import { ActionTypes } from './actions';
import type { ITemplate, ITemplateCreateState, ITemplateDocument } from './template-types';

export const initialState: ITemplateCreateState = {
  isFetching: true,
  template: undefined,
  fetchError: false,
  showAutoSaveIndicator: false,
  hasSavedAtLeastOnce: false,
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default function templateCreateReducer(state: ITemplateCreateState = initialState, action: any) {
  switch (action.type) {
    case ActionTypes.RESET: {
      return action.payload || { ...initialState };
    }
    case ActionTypes.FETCH_TEMPLATE_DONE: {
      const template: ITemplate = action.payload;
      return { ...state, isFetching: false, template };
    }
    case ActionTypes.UPDATE_TEMPLATE: {
      return { ...state, showAutoSaveIndicator: true };
    }
    case ActionTypes.UPDATE_TEMPLATE_DONE: {
      return { ...state, showAutoSaveIndicator: false, hasSavedAtLeastOnce: true };
    }
    case ActionTypes.UPLOAD_DOCUMENT: {
      const newDocument: ITemplateDocument = {
        // @ts-expect-error -- TODO: This object is half envelope document and half template document
        // Mongo stores id not documentId. UPLOAD_DOCUMENT_DONE case below maps id to documentId; see ITemplateWithMutilatedDocuments type docs
        documentId: action.payload.tempId,
        fileName: action.payload.file.name,
        blocks: [],
        blockGroups: [],
        isUploading: true,
      };
      // @ts-expect-error -- This code was written prior to enforcing lint rules
      return update(state, { template: { documents: { $push: [newDocument] } } });
    }
    case ActionTypes.UPLOAD_DOCUMENT_DONE: {
      const i = state.template!.documents.findIndex((d) => d.documentId === action.payload.tempId);
      return update(state, {
        template: {
          documents: {
            [i]: {
              documentId: { $set: action.payload.document.id },
              order: { $set: action.payload.document.order },
              numberOfPages: { $set: action.payload.document.numPages },
              isUploading: { $set: false },
            },
          },
        },
      });
    }
    case ActionTypes.ADD_RECIPIENT: {
      return update(state, {
        template: { recipients: { $push: [action.payload] } },
      });
    }
    case ActionTypes.DELETE_RECIPIENT_DONE: {
      const recipientId = action.payload;
      const filteredRecipients = state.template!.recipients.filter((r) => r.id !== recipientId);
      return update(state, {
        template: { recipients: { $set: filteredRecipients } },
      });
    }
    case ActionTypes.UPDATE_RECIPIENT: {
      return { ...state, showAutoSaveIndicator: true };
    }
    case ActionTypes.UPDATE_RECIPIENT_DONE: {
      const i = state.template?.recipients.findIndex((d) => d.id === action.payload.recipientId);
      return update(state, {
        showAutoSaveIndicator: { $set: false },
        hasSavedAtLeastOnce: { $set: true },
        template: {
          recipients: {
            // @ts-expect-error -- This code was written prior to enforcing lint rules
            [i]: { $set: action.payload.recipient },
          },
        },
      });
    }
    case ActionTypes.CHANGE_RECIPIENT_TITLE: {
      const i = state.template?.recipients.findIndex((d) => d.id === action.payload.recipientId);
      return update(state, {
        template: {
          recipients: {
            // @ts-expect-error -- This code was written prior to enforcing lint rules
            [i]: { recipientTitle: { $set: action.payload.title } },
          },
        },
      });
    }
    case ActionTypes.API_ERROR: {
      return { ...state, isFetching: false, showAutoSaveIndicator: false, fetchError: true };
    }

    case ActionTypes.REORDER_DOCUMENTS: {
      return update(state, {
        template: {
          documents: { $set: action.payload },
        },
      });
    }

    case ActionTypes.UPDATE_DOCUMENTS: {
      return update(state, {
        template: {
          documents: { $set: action.payload },
        },
      });
    }

    case ActionTypes.DELETE_DOCUMENT: {
      const index = state.template!.documents.findIndex((d) => d.documentId === action.payload);
      return update(state, {
        template: {
          documents: { $splice: [[index, 1]] },
        },
      });
    }
    default: {
      return state;
    }
  }
}
